import React from 'react';
import { Container } from 'react-bootstrap';

import Classroom from '../components/data/Classroom'; // Only renders Classroom
import 'bootstrap/dist/css/bootstrap.min.css';
import './ClassroomPage.css';

const ClassroomPage = () => {
  return (
    <Container fluid className="classroom-container">
      <Classroom />
    </Container>
  );
};

export default ClassroomPage;
